<template>
  <v-simple-table dense>
    <template v-slot:default>
      <tbody>
        <tr v-if="reservation.excludedTaxesAndFees">
          <td>{{ $t("Excluded taxes and fees") }}:</td>
          <td>
            <span>{{ getCurrencySymbol(reservation.currency) }} {{ reservation.excludedTaxesAndFees }}</span>
          </td>
        </tr>
        <tr>
          <td><b>{{ $t("Total amount") }}:</b></td>
          <td>
            <b>{{ getCurrencySymbol(reservation.currency) }} {{ reservation.totalPrice }}</b>
          </td>
        </tr>
        <tr>
          <td colspan="2"></td>
        </tr>
        <tr>
          <td>{{ $t("Paid") }}:</td>
          <td>
            <span>{{ getCurrencySymbol(reservation.currency) }} {{ reservation.priceWithTax }}</span>
          </td>
        </tr>
        <tr v-if="reservation.excludedTaxesAndFees">
          <td>{{ $t("Pay on arrival") }}:</td>
          <td>
            <span>{{ getCurrencySymbol(reservation.currency) }} {{ reservation.excludedTaxesAndFees }}</span>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import CurrencyMixin from '@/lib/CurrencyMixin';

export default {
  mixins: [CurrencyMixin],
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
};
</script>
